import { defineComponent as _defineComponent } from 'vue'
import type { BookV1 } from '@ilteducation/content-registry-types';
import { ref, watch } from 'vue';
import { useDuplicateBooks } from '@/comp/use-duplicate-books';
import { useRealmLabel } from '@/foundations/helpers/defaultRealms';
import { useLanguageLabel } from '@/comp/use-ref-languages';

type Props = {
  book: BookV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateBooksTable',
  props: {
    book: null
  },
  emits: ["selected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'selected', selectedBooks: BookV1[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  book: BookV1;
}





const selectedBooks = ref<BookV1[]>([]);

const { books: duplicateBooks } = useDuplicateBooks(props.book);

const { realmLabel } = useRealmLabel();

const duplicateBooksTableHeaders = [
  { text: 'Link', value: 'id' },
  { text: 'Title', value: 'title' },
  { text: 'Market', value: 'realm' },
  { text: 'Text Language', value: 'languages.mainLanguage' },
  { text: 'Audio Languages', value: 'languages.audio' },
];

const { getLanguageLabel } = useLanguageLabel();

watch(selectedBooks, (newValue) => {
  emits('selected', newValue);
});

return { __sfc: true,props, emits, selectedBooks, duplicateBooks, realmLabel, duplicateBooksTableHeaders, getLanguageLabel }
}

})